import { useMediaQuery } from 'react-responsive';

export const useResponsiveWidth = (width: number) => useMediaQuery({ query: `(max-width: ${width}px)` });
export const useResponsiveHeight = (height: number) => useMediaQuery({ query: `(max-height: ${height}px)` });

export const useResponsive = () => {
  const isXS = useMediaQuery({ query: '(max-width: 480px)' });
  const isS = useMediaQuery({ query: '(max-width: 768px)' });
  const isM = useMediaQuery({ query: '(max-width: 1024px)' });
  const isL = useMediaQuery({ query: '(max-width: 1440px)' });
  const isXL = useMediaQuery({ query: '(min-width: 1440px)' });
  const isLandscape = useMediaQuery({ query: '(orientation: landscape)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  return {
    isXS,
    isS,
    isM,
    isL,
    isXL,
    isLandscape,
    isPortrait,
  };
};
